import type { TransportOperationDefinition } from "@/types_api/backend/transport/operations"

const WORKSPACE_ID_HEADER = "X-Coval-Workspace-Id"

export function applyWorkspaceRequestHeader({
  operation,
  requestHeaders,
  getWorkspaceId,
}: {
  operation: TransportOperationDefinition
  requestHeaders: Headers
  getWorkspaceId?: () => string | null
}): void {
  if (!operation.organizationRequired || operation.resource === "workspaces") {
    requestHeaders.delete(WORKSPACE_ID_HEADER)
    return
  }

  const explicitWorkspaceId = requestHeaders.get(WORKSPACE_ID_HEADER)?.trim()
  if (explicitWorkspaceId) {
    requestHeaders.set(WORKSPACE_ID_HEADER, explicitWorkspaceId)
    return
  }

  requestHeaders.delete(WORKSPACE_ID_HEADER)
  const contextWorkspaceId = getWorkspaceId?.()?.trim()
  if (contextWorkspaceId) {
    requestHeaders.set(WORKSPACE_ID_HEADER, contextWorkspaceId)
  }
}
